import React from 'react';

import { Container } from './_fileInput';

interface FileInput {
  icon?: string;
  inputText: string;
  acceptFile?: string;
  inputFile: File | undefined;
  setInputFile: Function;
}

export const FileInput: React.FC<FileInput> = ({
  icon,
  inputText,
  acceptFile,
  inputFile,
  setInputFile,
}) => {
  const handleSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;

    if (files && files.length < 0) {
      return;
    }

    if (files && files.length > 0) {
      const selectedFile = files[0];
      setInputFile(selectedFile);
    }
  };

  return (
    <Container background={icon}>
      <label className="file-input__label">
        <div className="file-input__icon"></div>

        <span className="file-input__text">
          {inputFile ? inputFile.name : inputText}
        </span>

        <input
          type="file"
          accept={acceptFile}
          onChange={(e) => handleSelectFile(e)}
        />
      </label>
    </Container>
  );
};
